import { normalizeCity } from './cityNormalization';

/**
 * يبني كائن preciseLocation وتحديثات المدينة/الحي من اختيار الخريطة.
 * يُستخدم لتوحيد منطق بناء الموقع بين خطوة الحجز والهيدر.
 *
 * @param {Object} selection - ناتج LocationPickerMap: { lat, lng, address, city, district }
 * @param {Object} formData - بيانات الحجز الحالية لاستخدامها كـ fallback (مثل region / cityLabel)
 * @returns {Object|null} updateData - كائن جاهز للتمرير إلى onUpdate في الحجز
 */
export const buildPreciseLocationFromSelection = (selection, formData) => {
  if (!selection) return null;

  const rawLat = selection.lat;
  const rawLng = selection.lng;

  const lat = typeof rawLat === 'number' ? rawLat : parseFloat(rawLat);
  const lng = typeof rawLng === 'number' ? rawLng : parseFloat(rawLng);

  if (!Number.isFinite(lat) || !Number.isFinite(lng) || (lat === 0 && lng === 0)) {
    return null;
  }

  const finalCity =
    selection.city ||
    formData?.cityLabel ||
    formData?.city ||
    'الرياض';

  const finalDistrict = selection.district || null;
  const finalAddress =
    selection.address ||
    (finalDistrict
      ? `الموقع: ${finalCity} — ${finalDistrict}`
      : `الموقع: ${finalCity}`);

  const preciseLocation = {
    lat,
    lng,
    address_text: finalAddress,
    city: finalCity,
    district: finalDistrict,
    source: 'pin',
  };

  const { cityKey, cityLabel: normalizedLabel } = normalizeCity(
    finalCity,
    formData?.region
  );

  const updateData = {
    preciseLocation,
  };

  if (cityKey) {
    updateData.city = cityKey;
    updateData.cityLabel = normalizedLabel || finalCity;
  } else if (finalCity) {
    updateData.city = finalCity;
    updateData.cityLabel = finalCity;
  }

  if (finalDistrict) {
    updateData.district = finalDistrict;
  }

  return updateData;
};

